import { useEffect, useState } from 'react';

import { FEATURE_FLAGS } from '../common/context/FlagsContext';
import { useFeatureFlagsValue } from '../common/context/FlagsValueContext';
import { getFeaturesByClientId } from '../utils/getFeaturesByClientId';

export function usePasskeyEnabled() {
  const [passkeyEnabled, setPasskeyEnabled] = useState(false);
  const flagsContext = useFeatureFlagsValue();
  useEffect(() => {
    const { isPasskeyEnabled } = getFeaturesByClientId();
    const enabled =
      flagsContext?.flags?.find(v => v?.flagKey === FEATURE_FLAGS.ENABLE_PASSKEY?.toString())?.flagValue ?? false;
    const isFlagEnabled = enabled === true || enabled === 'true';
    setPasskeyEnabled(isFlagEnabled && isPasskeyEnabled);
  }, [flagsContext]);

  return { passkeyEnabled };
}
